import React, { useEffect, useState } from "react";
import { TabsData } from "./Tabs";
import { useNavigate } from "react-router-dom";

const TabsSection = (props) => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [currentTab, setcurrentTab] = useState("");

  const path = window.location.href;
  const endPath = path.split("/");

  console.log("props",props)

  useEffect(() => {
    // business_listings
    if (endPath[3] === "business-listings") {
      setData(TabsData.business_listings);
      if (endPath[4] === "all-listings") {
        setcurrentTab(TabsData.business_listings[0]);
      }
      if (endPath[4] === "new-listings") {
        setcurrentTab(TabsData.business_listings[1]);
      }
      if (endPath[4] === "in-review-listings") {
        setcurrentTab(TabsData.business_listings[2]);
      }
      if (endPath[4] === "published-listings") {
        setcurrentTab(TabsData.business_listings[3]);
      }
      if (endPath[4] === "declined-listings") {
        setcurrentTab(TabsData.business_listings[4]);
      }
      if (endPath[4] === "featured-listings") {
        setcurrentTab(TabsData.business_listings[5]);
      }
      if (endPath[3] === "customer-listings") {
        setcurrentTab(TabsData.customer_listings[0]);
      }
    }
    // vouchers
    if (endPath[3] === "vouchers") {
      setData(TabsData.vouchers);
      if (endPath[4] === "vouchers-dashboard") {
        setcurrentTab(TabsData.vouchers[0]);
      }
      if (endPath[4] === "manage-vouchers") {
        setcurrentTab(TabsData.vouchers[1]);
      }
      if (endPath[4] === "featured-vouchers") {
        setcurrentTab(TabsData.vouchers[2]);
      }
      if (endPath[4] === "transactions") {
        setcurrentTab(TabsData.vouchers[3]);
      }
    }

    // coupons
    if (endPath[3] === "coupons") {
      setData(TabsData.coupons);
      if (endPath[4] === "coupons-dashboard") {
        setcurrentTab(TabsData.coupons[0]);
      }
      if (endPath[4] === "manage-coupons") {
        setcurrentTab(TabsData.coupons[1]);
      }
      if (endPath[4] === "featured-coupons") {
        setcurrentTab(TabsData.coupons[2]);
      }
       if (endPath[4] === "my-coupons") {
         setcurrentTab(TabsData.coupons[3]);
         
       }
       if (endPath[4] === "bussiness-listing") {
         setcurrentTab(TabsData.coupons[4]);
       }
    }

    // dashboard-table
    if (endPath[3] === "dashboard") {
      setData(TabsData.DashboardTable);
      if (endPath[3] === "dashboard") {
        setcurrentTab(TabsData.DashboardTable[0]);
      }
      if (endPath[4] === "all-categories") {
        setcurrentTab(TabsData.DashboardTable[1]);
      }
    }

    // communications
    if (endPath[3] === "communications") {
      setData(TabsData.comunications);
      if (endPath[4] === "manage-templates") {
        setcurrentTab(TabsData.comunications[0]);
      }
      if (endPath[4] === "bulk-notify") {
        setcurrentTab(TabsData.comunications[1]);
      }
    }
    // marketplace_setup
    if (endPath[3] === "marketplace-setup") {
      setData(TabsData.marketplace_setup);
      if (endPath[4] === "home-page-setup") {
        setcurrentTab(TabsData.marketplace_setup[0]);
      }
      if (endPath[4] === "pages") {
        setcurrentTab(TabsData.marketplace_setup[1]);
      }
      if (endPath[4] === "categories") {
        setcurrentTab(TabsData.marketplace_setup[2]);
      }
      if (endPath[4] === "privacy-policy") {
        setcurrentTab(TabsData.marketplace_setup[3]);
      }
      if (endPath[4] === "terms-&-conditions") {
        setcurrentTab(TabsData.marketplace_setup[4]);
      }
      if (endPath[4] === "profile") {
        setcurrentTab(TabsData.marketplace_setup[5]);
      }
    }
    // user_administration
    if (endPath[3] === "user-administration") {
      setData(TabsData.user_administration);
      if (endPath[4] === "manage-users") {
        setcurrentTab(TabsData.user_administration[0]);
      }
      if (endPath[4] === "login-history") {
        setcurrentTab(TabsData.user_administration[1]);
      }
    }
    if (endPath[3] === "customer-listings") {
      setData(TabsData.customer_listings);
    }

  }, [endPath]);


  useEffect(() => {
    // events listing 
    if (endPath[3] === "events-list") {
      const eventsTabs = [...TabsData.events_listings];

      // Only modify the label for display — don't change the base value
      const displayTabs = eventsTabs.map((tab, index) => {
        if (index === 1 && props.count) {
          return `${tab} [${props.count}]`; // Only "New Events" gets the count
        }
        return tab;
      });

      setData(displayTabs);
      if (endPath[4] === "all-events") {
        setcurrentTab(TabsData.events_listings[0]);
      }
      if (endPath[4] === "new-events") {
        setcurrentTab(TabsData.events_listings[1]);
      }
      if (endPath[4] === "in-review-events") {
        setcurrentTab(TabsData.events_listings[2]);
      }
      if (endPath[4] === "published-events") {
        setcurrentTab(TabsData.events_listings[3]);
      }
      if (endPath[4] === "declined-events") {
        setcurrentTab(TabsData.events_listings[4]);
      }

    }
  }, [props.count])

  const handleToggleTab = (e, key) => {
    console.log(data[key], "data[key]");
    // console.log("/" + endPath[3] + "/");

    const rawLabel = data[key].split(" [")[0];
    console.log("rawLabel", rawLabel)
    if (rawLabel == "Top Categories") {
      setcurrentTab(data[key]);
      const url = data[key].split(" ").join("-").toLowerCase();
      navigate("/" + endPath[3]);
    } else {
      setcurrentTab(rawLabel);
      const url = rawLabel.split(" ").join("-").toLowerCase();
      navigate("/" + endPath[3] + "/" + url);
    }
  };
  
  const handleToggleEventsTab = (e, key) => {
  const rawTab = TabsData.events_listings[key]; // unmodified label
  setcurrentTab(data[key]); // data[key] includes [10] if present
  const url = rawTab.split(" ").join("-").toLowerCase();
 

  navigate("/" + endPath[3] + "/" + url);
};

  

  return (
    <>
      <ul className="tabs_ul">
        {data.map((item, key) => {
          return (
            <li
              key={item}
              className={`tabs_li ${currentTab === item && "activeTab"}`}
              onClick={(e) => props.count > 0 ?handleToggleEventsTab(e,key) :handleToggleTab(e, key)}
            >
              {item}
            </li>
          );
        })}


      </ul>
    </>
  );
};

export default TabsSection;
